module.exports = __webpack_public_path__ + "assets/74d49aa61ee5ead8e72c80638a5aabc2.json";